export function ujscontexts() {
    if ( !window.ujscontexts ) {
        window.ujscontexts = {
            names:[],
            contexts:{},
            ujs: {}
        }
    }
}